module.exports = __webpack_public_path__ + "static/media/ic_wcag_text_small.94917a81.svg";